import { Link } from "react-router-dom";
import { SERVICES, SECTORS, LOCATIONS } from "@/data/seoPages";

const LOGO =
  "https://customer-assets.emergentagent.com/job_design-led-builds/artifacts/p4d7ltzn_IMG-20260527-WA0015.jpg";

const Column = ({ title, links, testid }) => (
  <div data-testid={testid}>
    <div className="overline mb-4">{title}</div>
    <ul className="space-y-2 text-sm text-black/70">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="hover:text-black transition-colors">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t hairline bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 lg:py-16">
        <div className="grid grid-cols-12 gap-y-8 gap-x-4 lg:gap-8 items-start">
          <div className="col-span-12 lg:col-span-4">
            <img
              src={LOGO}
              alt="Anderston Group"
              className="h-20 lg:h-28 w-72 lg:w-96 object-cover object-center"
              style={{ mixBlendMode: "multiply" }}
            />
            <p className="mt-5 max-w-md text-sm text-black/60 leading-relaxed">
              Design-led interior fit-outs for workspaces, bars, restaurants and
              distilleries. All trades in-house — people on site, AI in the
              engine room.
            </p>
            <ul className="mt-6 space-y-2 text-sm text-black/70">
              <li>Scotland · UK-wide delivery</li>
              <li>
                <a className="hover:text-black" href="mailto:hello@anderstongroup.co.uk">
                  hello@anderstongroup.co.uk
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <Column
              title="Services"
              testid="footer-services"
              links={SERVICES.map((s) => ({ label: s.name, to: `/services/${s.slug}` }))}
            />
          </div>
          <div className="col-span-6 lg:col-span-2">
            <Column
              title="Sectors"
              testid="footer-sectors"
              links={SECTORS.map((s) => ({ label: s.name, to: `/sectors/${s.slug}` }))}
            />
          </div>
          <div className="col-span-6 lg:col-span-2">
            <Column
              title="Where we work"
              testid="footer-locations"
              links={LOCATIONS.map((l) => ({ label: l.name, to: `/fit-out/${l.slug}` }))}
            />
          </div>
          <div className="col-span-6 lg:col-span-2">
            <Column
              title="Company"
              testid="footer-company"
              links={[
                { label: "Workshop", to: "/#workshop" },
                { label: "Intelligence", to: "/#intelligence" },
                { label: "Process", to: "/#process" },
                { label: "Journal", to: "/blog" },
                { label: "Contact", to: "/#contact" },
              ]}
            />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t hairline flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-black/50">
          <div>© {new Date().getFullYear()} Anderston Group. All rights reserved.</div>
          <div className="tracking-[0.22em] uppercase">Scotland · UK</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
